import './reset.css';
import './style.css';

import commonPageService from 'pcCommon/services/commonPageService';
import video from 'globalCommon/utils/video';
import { syncRender } from 'globalCommon/services/syncRender';

const init = () => {
    commonPageService({ renderAfter: syncRender });
    video.init();
};

init();
